require('./bootstrap');
const {setDynamicRules, setInputFieldRules} = require("./components/functions");

$(function () {
    'use strict';

    let body = $('body'),
        allowed = true;

    // Fade out global page overlay
    Fnc.showGlobalLoadingOverlay(body);

    Init.initJs(body);
    Fnc.addCollapsedClass(body);

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    // Hide mobile menu in desktop
    $(window).resize(function () {
        if ($(window).width() >= 940 && $('#menu_popup').is(':visible')) {
            $('.menu-hamburger').removeClass('active');
            $('body').removeClass('ovh');
            $('.pop-up-meniu').hide();
            $('.main_menu').addClass('deactiveLvlMenu');
        }
    }).resize();

    // Form on change event
    body.on('classChange', 'form', function () {
        // Set allowed value according to form state
        setTimeout(function () {
            allowed = !body.find('form.not-submitted').length;
        }, 10);
    });

    // Body on click event
    body.on('click', function (e) {
        // Set allowed value according to pressed button and form state
        if ($(e.target).attr('type') === 'submit') {
            allowed = true;
        } else {
            allowed = !body.find('form.not-submitted').length;
        }
    });

    // Before unload event listener
    window.addEventListener('beforeunload', function (event) {
        // Set alert according to allowed value
        if (!allowed) {
            event.stopPropagation();
            event.preventDefault();
            return event.returnValue = 'You have unsaved changes.';
        }
    });

    // Add loading to button
    $(document).on('click', '.ui.button.btn-ld', function () {
        (function () {
            $(this).addClass('loading disabled')
        }).call(this)
    });

    // Auth checkbox check
    $(document).on('click', '#login', function () {
        if (!$('#terms-conditions').is(':checked')) {
            $('#login').removeClass('loading disabled')
        }
    });

    $('.unlimited-check input').trigger("change");

    let stepsContainer = $('#responsive-steps');
    let mobileMenu = '<div class="steps-mobile-menu"><a href="#" class="icon" id="steps-menu-icon">...</a></div>';

    $(mobileMenu).appendTo(stepsContainer);

    $(document).on('click', '#steps-menu-icon', function (e) {
        e.preventDefault();

        if (stepsContainer.hasClass('responsive')) {
            stepsContainer.removeClass('responsive');
        } else {
            stepsContainer.addClass('responsive');
        }
    });

    Fnc.showDynamicField($('.select.select-toggle'));

    // Display dynamic fields
    $(document).on('select2:select', '.select.select-toggle', function () {
        Fnc.showDynamicField($(this));
    });

    $(document).on('select2:close', 'select', function () {
        $(this).valid();
    });

    // disable step link
    $(document).on('click', '.form-steps .disabled a', function (e) {
        e.preventDefault();
    });

    // Link delete confirm
    $(document).on('click', 'a[delete-confirm]', function (e) {
        let _this = $(this),
            mgs = _this.attr('delete-confirm'),
            method = _this.attr('data-method'),
            deleteConfirmBtn = $('.delete-confirm-button'),
            ajaxContainer = _this.attr('ajax-container');

        if (typeof (method) === 'undefined' || method.trim() === '') {
            method = 'GET';
        }

        if (typeof (_this.attr('new-href')) === 'undefined' || _this.attr('new-href') === '') {
            _this.attr('new-href', _this.attr('href'));
        }

        $('#delete_confirm_model').modal('show');
        $('#delete_confirm_model h6').html(mgs);

        deleteConfirmBtn.attr('href', _this.attr('new-href'));
        deleteConfirmBtn.attr('data-method', method);

        // reload when need
        if (_this.hasClass('reload_page')) {
            deleteConfirmBtn.addClass('reload_page');
        } else {
            deleteConfirmBtn.removeClass('reload_page');
        }

        if (typeof (_this.attr('no-ajax')) !== 'undefined') {
            deleteConfirmBtn.removeClass('ajax_link');
        } else if (_this.hasClass('link-method')) {
            deleteConfirmBtn.removeClass('ajax_link');
            deleteConfirmBtn.attr('link-method', method);
        } else {
            if (!deleteConfirmBtn.hasClass('ajax_link')) {
                deleteConfirmBtn.addClass('ajax_link');
            }
        }

        if (ajaxContainer !== undefined) {
            deleteConfirmBtn.attr('ajax-container', ajaxContainer);
        }

        e.stopImmediatePropagation();
        e.preventDefault();
    });

    // validate form if it has
    $(document).on('click', '.delete-confirm-button', function (e) {
        let _this = $(this),
            ajaxContainer = _this.attr('ajax-container'),
            overlay = $('#' + _this.closest('form.confirm-delete-form').data('overlay-id'));

        overlay.removeClass('d-none');

        if (ajaxContainer !== undefined && ajaxContainer.trim() !== '' && $('.confirm-delete-form').valid()) {
            $('.modal').modal('hide');
            Fnc.applicationFileDeleteHandler(_this.attr('ajax-container'));
            NestableComp.removeNestableItem($('li.dd-item[data-id="' + ajaxContainer + '"]'), ajaxContainer);
            overlay.addClass('d-none');

            e.stopImmediatePropagation();
            e.preventDefault();
        }
    });

    $(document).on('click', 'a.ajax_link', function (e) {
        e.preventDefault();

        let url = $(this).attr('href');
        let a_ = $(this);
        let method = $(this).attr('data-method');

        // Skip if previous ajax calling
        if (a_.hasClass('loading')) {
            return;
        }

        // Default data
        let data = {
            '_token': CSRF_TOKEN
        };

        if (typeof (method) === 'undefined' || method.trim() === '') {
            method = 'GET';
        }

        // Add loader
        a_.addClass('loading');
        $('.modal-content').append(Fnc.htmlLoader());

        $.ajax({
            method: method,
            url: url,
            data: data
        }).done(function (msg) {
            let type = 'success';

            if (typeof (msg.status) !== 'undefined') {
                type = msg.status;
                msg = msg.message;
            }

            if (msg.indexOf('is-error') !== -1) {
                type = 'error';
            }

            try {
                let data = JSON.parse(msg);
                type = data.status;
                msg = data.message;
            } catch (e) {
            }

            if (typeof (msg) == 'object') {
            }

            // Reload table if exists
            if ($('.listing-form').length > 0) {
                Listing.tableFilter($('.listing-form'));
            }

            if (msg !== '' && !a_.hasClass('reload_page')) {
                Fnc.notify(type, LANG_NOTIFY[type], msg);
            }

            // Remove loader
            a_.removeClass('loading');
            $('.modal-content .overlay').remove();

            if (type !== 'error') {
                $('.modal').modal('hide');
            }

            // reload when need
            if (a_.hasClass('reload_page')) {
                location.reload();
            }
        });
    });

    $(document).on('click', 'button[type="submit"]', function () {
        if (!$('form').valid()) {
            Fnc.collapseIfHasError(body);
        }
    });

    // Delete list item
    $(document).on('click', 'button.list-delete', function () {
        let _this = $(this),
            listItem = _this.closest('li.list-item');

        // Enable list-item options
        _this.closest('.list')
            .find('.list-item.list-add-item select.select.select-search option[value="' + listItem.find('.list-item-id').val() + '"]')
            .attr('disabled', false);
        Fnc.addNotSubmittedClass(_this);
        listItem.remove();
        Fnc.notify('success', LANG_NOTIFY['success'], LANG_NOTIFY['item_deleted']);
    });

    // Add list item
    $(document).on('select2:select', '.list .list-add-item .select.select-search', function () {
        let _this = $(this),
            overlay = $('#' + _this.data('overlay-id')),
            optionValue = _this.val(),
            optionText = _this.find('option:selected').text(),
            listContainer = _this.closest('.list'),
            listAddItemSelector = _this.closest('.list-add-item');

        $.ajax({
            url: _this.attr('data-href'),
            type: _this.attr('data-method'),
            data: {
                _token: CSRF_TOKEN,
                atype: $('#atype').val(),
                type: optionValue,
                text: optionText
            },
            success: function (data) {
                $(data).insertBefore(listAddItemSelector);
                // Disable list-item options
                _this.closest('select.select.select-search').find('option[value="' + optionValue + '"]').attr('disabled', true);
                Init.initJs(listContainer.find(`.list-item[data-id="${$(data).data('id')}"]`));
                Fnc.addCollapsedClass(listContainer);
                Fnc.addNotSubmittedClass(_this);
                Fnc.showDynamicField($('.select.select-toggle'));
                Fnc.disableEmptyDependentFields();
                overlay.hide();
                Fnc.notify('success', LANG_NOTIFY['success'], LANG_NOTIFY['new_item_added']);
            },
            error: function () {
                Fnc.notify('error', LANG_NOTIFY['error'], LANG_NOTIFY['check_try_again']);
                overlay.hide();
            },
            beforeSend: function () {
                overlay.show();
            }
        });

        _this.val('').trigger('change');
    });

    // Disable list-item options according to list
    $('.list').find('li.list-item').each(function () {
        let _this = $(this);

        _this.closest('.list')
            .find('.list-item.list-add-item select.select.select-search option[value="' + _this.find('.list-item-id').val() + '"]')
            .attr('disabled', true)
    });

    $(document).on('change', 'input.btn-file-upload', function () {
        let _this = $(this);

        Fnc.applicationFileUploadHandler(_this.prop('name'), _this.prop('files')[0]);
        Fnc.addNotSubmittedClass(_this);
    });

    // Load select2 ajax content
    $(document).on('select2:select', '.select-search.select2-nestable', function () {
        Fnc.addListItem($(this));
    });

    // Disable select2-nestable options according to nestable list
    $($('select.select-search.select2-nestable').data('content-body')).find('li.dd3-item').each(function () {
        let _this = $(this);

        $('select.select-search.select2-nestable[name="' + _this.data('type') + '"]')
            .find('option[value="' + _this.data('id') + '"]')
            .attr('disabled', true);
    });

    // Disable all empty fields form on load
    Fnc.disableEmptyDependentFields();

    body.find('.dependent[data-depend-id]').each(function () {
        Fnc.handleDependentFields($(this));
    });

    // Dependent fields on change event
    $(document).on('dp.change change', '.input-group:has(.dependent[data-depend-id]), .dependent[data-depend-id]', function (e) {
        Fnc.handleDependentFields($(this));

        e.stopImmediatePropagation();
        e.preventDefault();
    });

    // Loop for select input with `data-dynamic-rule-ids` attribute
    $('select[data-dynamic-rule-ids]').each(function () {
        Fnc.handleDynamicRules($(this));
    });

    // On select event of select input with `data-dynamic-rule-ids` attribute
    $(document).on('select2:select', 'select[data-dynamic-rule-ids]', function () {
        Fnc.handleDynamicRules($(this));
    });

    Fnc.disableDocumentAddButton();

    // Add document
    $(document).on('click', 'button.document-add', function (e) {
        let _this = $(this),
            overlay = $('#' + _this.data('overlay-id')),
            documentList = $('.document-list'),
            length = documentList.find('.document-additional').length;

        if (length < 10) {
            overlay.show();
            setTimeout(function () {
                $.ajax({
                    type: 'POST',
                    data: {
                        type: 'additional_' + (length + 1),
                        name: '',
                        uploaded: 0,
                        edit: 1,
                        additionalDoc: 1,
                        required: 0,
                        info: null
                    },
                    cache: false,
                    url: _this.data('url'),
                    success: function (response) {
                        documentList.append(response);
                        Fnc.addNotSubmittedClass(documentList);
                        Fnc.notify('success', LANG_NOTIFY['success'], ADDITIONAL_ADDED);
                        overlay.hide();
                    },
                    error: function () {
                        Fnc.notify('error', LANG_NOTIFY['error'], SOMETHING_WENT_WRONG);
                    }
                });
            }, 100);
        } else {
            Fnc.notify('error', LANG_NOTIFY['error'], MAX_FILE_NUMBER_REACHED);
        }

        Fnc.disableDocumentAddButton();

        e.stopImmediatePropagation();
        e.preventDefault();
    });

    // Add additional info form item
    $(document).on('click', 'button.additional-info-add', function (e) {
        let _this = $(this),
            overlay = $('#' + _this.data('overlay-id')),
            list = _this.closest('.list ol'),
            newId = 'new-' + (list.find('.list-unique-item').length + 1);

        overlay.show();
        setTimeout(function () {
            $.ajax({
                type: 'POST',
                data: {
                    id: newId
                },
                cache: false,
                url: _this.data('url'),
                success: function (response) {
                    $(response).insertBefore(list.find('.list-add-item'));
                    Fnc.addNotSubmittedClass(list);
                    Init.initJs(list.find(`.list-item.list-unique-item[data-id=${$(response).data('id')}]`));
                    Fnc.notify('success', LANG_NOTIFY['success'], LANG_NOTIFY['new_item_added']);
                    overlay.hide();
                },
                error: function () {
                    Fnc.notify('error', LANG_NOTIFY['error'], SOMETHING_WENT_WRONG);
                }
            });
        }, 100);

        e.stopImmediatePropagation();
        e.preventDefault();
    });

    $(document).on('change', 'input:checkbox[data-toggle-btn]', function () {
        Fnc.toggleButton($(this));
    });

    $(document).on('click', '.open-menu-popup', function () {
        Fnc.openMenuPopup();
    });

    // Value setter event. Sets selected option's text to the specified id
    $(document).on('select2:select', 'select[data-val-setter]', function (e) {
        $('#' + $(this).data('val-setter')).html(e.params.data.text).val(e.params.data.text);
    });

    $(document).on('click', '.modal-pdf', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        CustomModal.create($(this), Fnc.loadPDFViewer);
    });

    $(document).on('click', '.document-download', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        Fnc.downloadDocument($(this).closest('.modal'));
    });

    // Close alert
    $(document).on('click', '.alert .close', function () {
        $(this).parent('.alert').alert('close');
    });

    $(document).one('submit', 'form', function (e) {
        e.preventDefault();
        let _this = $(this);

        $('#' + _this.data('overlay-id')).removeClass('d-none');
        _this.submit();
    });

    $(document).on('click', 'a', function () {
        $('#' + $(this).data('overlay-id')).removeClass('d-none');
    });

    $(document).on('visibilitychange', function () {
        if (document.visibilityState === 'visible') {
            $('#global-loader:not(.d-none)').addClass('d-none');
        }
    });
});
